import {useMutation, useQuery} from "@apollo/client";
import {GetAdventures4User, GetKampagne4User} from "../../GraphQL/AdventureQueries";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {RootState} from "../../redux/store";
import React, {useEffect} from "react";
import {setActiveContent, setIsAppLoading} from "../../redux/slices/content/contentSlice";
import {DeleteSharp, PlayArrowSharp} from "@mui/icons-material";
import Button from "../../Atoms/Button";
import {ActiveContent} from "../../redux/slices/content/contentType";
import {setAdventure} from "../../redux/slices/adventure/adventureSlice";
import {UpdateLastPlayedAdventure} from "../../GraphQL/UserMutations";
import {toInteger} from "lodash";
import {toast} from "react-toastify";
import {updateLastPlayed} from "../../redux/slices/user/userSlice";
import {VeneList} from "../../Atoms/VeneList";
import {AdventureState} from "../../redux/slices/adventure/adventureType";

export const Kampagne = () => {
    const user = useAppSelector((state: RootState) => state.user);
    const dispatch = useAppDispatch();

    const {
        data: adventureResultData,
        loading: adventureResultLoading,
        error: adventureResultError
    } = useQuery(GetKampagne4User, {variables: {userId: Number(user.userId)}, fetchPolicy: 'network-only'});
    
    const [ updateLastPlayedHook, {
        loading: updateLastPlayedLoading,
        error: updateLastPlayedError
    }] = useMutation(UpdateLastPlayedAdventure)

    const [adventureData, setAdventureData] = React.useState<any[]>([])

    useEffect(() => {
        if (adventureResultData && !adventureResultLoading) {
            setAdventureData(adventureResultData.getKampagne4User);
        }
    }, [adventureResultData])

    useEffect(() => {
        if (adventureResultLoading || updateLastPlayedLoading) {
            dispatch(setIsAppLoading({loadingText: 'Abenteuer werden geladen...', isAppLoading: true}))
        } else {
            dispatch(setIsAppLoading({loadingText: '', isAppLoading: false}))
        }
    }, [adventureResultLoading, updateLastPlayedLoading])

    useEffect(() => {
        if (updateLastPlayedError) {
            toast("Fehler beim Speichern der Last Played Referenz")
        }
    }, [updateLastPlayedError]);

    const handlePlayKampagne = async (adventure: any) => {
        await updateLastPlayedHook({
            variables: {
                userId: toInteger(user.userId),
                adventureId: toInteger(adventure.adventureId)
            }
        })
        
        dispatch(updateLastPlayed(Number(adventure.adventureId)))
        
        dispatch(setAdventure({
            adventureId: adventure.adventureId,
            adventureDesc: adventure.adventureDescription,
            adventureName: adventure.adventureName,
            user_to_adventure: []
        }))
        dispatch(setActiveContent(ActiveContent.KampagnePlay))
    }

    return (
        <div className='row justify-content-center mt-3'>
            <div className='col-10 adventure-container'>
                <VeneList<AdventureState>
                    data={adventureData}
                    colDefinition={[
                        {
                            colName: "Name",
                            keyName: "adventureName"
                        }
                    ]}
                    buttonConfig={[
                        {
                            icon: <PlayArrowSharp/>,
                            onClick: async (dataEntry) => { await handlePlayKampagne(dataEntry)}
                        }
                    ]}
                />
            </div>
        </div>
    )
}